import type { EnumLiteralsOf } from '@/types'
import { Flex, Label, Radio } from 'pcln-design-system'
import { type ChangeEvent } from 'react'
import styled from 'styled-components'
import type { PackageFormTripType } from '../types'
import { TripTypeInfos } from './TripTypes'

type TripTypeRadiosPropType = Readonly<{
  watchTripType: string
  tripTypes: ReadonlyArray<EnumLiteralsOf<typeof TripTypeInfos>>
  onChange: (tripType: PackageFormTripType) => void
}>

const TripTypeLabel = styled(Label)`
  cursor: pointer;
  text-size-adjust: none;
`

function isValidTripType(tripType: string): tripType is PackageFormTripType {
  return (
    tripType === 'STAY:FLY' ||
    tripType === 'STAY:FLY:DRIVE' ||
    tripType === 'FLY:DRIVE' ||
    tripType === 'STAY:DRIVE'
  )
}
function TripTypeRadios({ watchTripType, tripTypes, onChange }: TripTypeRadiosPropType) {
  return (
    <Flex
      alignItems={['left', null, 'center']}
      flexDirection={['column', null, 'row']}
      justifyContent='space-between'
    >
      <Flex flexDirection='row' flexWrap='wrap'>
        {tripTypes.map((typeInfo) => (
          <Flex mr={[0, null, 3]} alignItems='center' key={typeInfo.id} width={[1 / 2, null, 'auto']}>
            <TripTypeLabel fontSize={0} fontWeight={500} nowrap>
              <Radio
                id={typeInfo.id}
                type='radio'
                name='tripType'
                value={typeInfo.tripType}
                checked={watchTripType === typeInfo.tripType}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  const tripType = e.target.value
                  if (isValidTripType(tripType)) {
                    onChange(tripType)
                  }
                }}
              />{' '}
              {typeInfo.typeLabel}
            </TripTypeLabel>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}

export default TripTypeRadios
